import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Typography, Button, IconButton, TextField } from '@mui/material';
import { useUpdateNoteMutation } from 'src/common/apis/FlorenceApi';
import { SaveSheet } from 'src/common/types/SaveSheet';
import { getSheetName } from 'src/florence/utils/getSheetName';

import { ReactComponent as CancelIconBlue } from '../../../../common/assets/icons/cancel_icon_blue.svg';

type Props = {
  note: SaveSheet;
  onClose: () => void;
};

const NoteRenamePopup: React.FC<Props> = ({ onClose, note }) => {
  const [value, setValue] = React.useState('');
  const [updatedSheet, setUpdatedSheet] = React.useState(note);
  const [updateNoteRequest, { isLoading }] = useUpdateNoteMutation();

  React.useEffect(() => {
    setUpdatedSheet((prev) => {
      return { ...prev, name: value };
    });
  }, [value]);

  const renameSheet = async () => {
    await updateNoteRequest(updatedSheet);
    onClose();
  };

  return (
    <Box
      sx={{
        maxWidth: '575px',
        minHeight: '365px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flex: 1,
        borderRadius: '15px',
        padding: '30px',
        flexDirection: 'column',
      }}
    >
      <IconButton
        disabled={isLoading}
        onClick={onClose}
        sx={{ alignSelf: 'flex-start', justifySelf: 'right' }}
      >
        <CancelIconBlue />
      </IconButton>
      <Typography
        sx={{
          alignSelf: 'center',
          whiteSpace: 'break-spaces',
          textAlign: 'center',
          mb: '24px',
        }}
        color='text.primary'
        variant='h5'
      >
        Rename
      </Typography>
      <TextField
        sx={{ mt: '30px' }}
        placeholder={getSheetName(note)}
        variant='standard'
        fullWidth
        type='text'
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={isLoading}
      />
      <Box
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button
          disabled={isLoading}
          onClick={onClose}
          disableElevation
          color='appGray2'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
            marginRight: '15px',
          }}
        >
          <Typography color='white'>Cancel</Typography>
        </Button>
        <LoadingButton
          onClick={renameSheet}
          loading={isLoading}
          disableElevation
          color='primary'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
          }}
        >
          <Typography color='white'>Ok</Typography>
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default NoteRenamePopup;
